import { useDispatch } from "react-redux";

import {
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
} from "@/redux/login/loginSlice";
import Footer from "../common/footer/Footer";
import Header from "../common/header/DefaultHeader";
import MobileMenu from "../common/header/MobileMenu";
import PopupSignInUp from "../common/PopupSignInUp";
import WhyChoose from "../common/WhyChoose";
import BreadCrumbBanner from "./BreadCrumbBanner";
import OurMission from "./OurMission";
import { useNavigate } from "react-router";
import React, { useState, useEffect } from "react";
import { getWebCMS } from "@/api/PDP";
import { trackButtonClick } from "@/utils/analytics";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [webCMS, setWebCMS] = useState(null);

  useEffect(() => {
    const fetchWebCMS = async () => {
      try {
        const response = await getWebCMS("global/aboutUsData");
        setWebCMS(response?.results[0]);
      } catch (error) {
        console.error("Failed to fetch CMS data:", error);
      }
    };

    fetchWebCMS();
  }, []);

  const navigateToRegister = (e) => {
    e.preventDefault();
    dispatch(setLoginModal(true));
    dispatch(setLoginTab("regsiterTab"));
    dispatch(setLoginCallLocation("popup"));

    trackButtonClick({
      eventName: "about_us_register_click",
      eventSource: "Register Button Click",
      eventCategory: "about-us",
    });
  };

  return (
    <>
      {/* <!-- Main Header Nav --> */}
      <Header />

      {/* <!--  Mobile Menu --> */}
      <MobileMenu />

      {/* <!-- Modal --> */}
      <PopupSignInUp />

      {/* <!-- Inner Page Breadcrumb --> */}
      <BreadCrumbBanner />

      {/* <!-- About Text Content --> */}
      <section className="about-section">
        <div className="container">
          {/* End .row */}

          <div className="row">
            <OurMission />
          </div>
          {/* End .row */}
        </div>
      </section>
      <div class="top-bg"></div>
      <section className="pb-0">
        <div className="container">
          <div class="row">
            <div class="col-md-6 col-lg-6 col-xl-6">
              <div class="for_blog feat_property">
                <div class="thumb">
                  <a href="">
                    <img
                      class="img-whp w-100  cover"
                      src="https://image-prod.hubzu.com/about-us/buyer.jpg"
                      alt="bh1.jpg"
                    />
                  </a>
                  <span className="image-title-cap">Buyers</span>
                </div>
                <div class="details">
                  <div class="tc_content_custom">
                    <div className="buyers-content">
                      Whether you're looking for your next investment or a place
                      to live, take your pick of thousands of properties
                      available all over the country. Hubzu provides access to
                      properties throughout their entire lifecycle. From
                      traditional and short sales to bank-owned and foreclosure.
                      Our marketing platform provides buyers an easy and
                      efficient way to reach their investment goals by providing
                      valuable property information, exclusive properties and
                      live customer support.{" "}
                      <a href="/auctions?listingType=AUCN">Click here</a> to
                      start browing through available inventory.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6 col-xl-6">
              <div class="for_blog feat_property">
                <div class="thumb">
                  <a href="">
                    <img
                      className="img-whp w-100  cover"
                      src="https://image-prod.hubzu.com/about-us/seller.jpg"
                      alt="bh1.jpg"
                    />
                  </a>
                  <span className="image-title-cap">Sellers</span>
                </div>
                <div class="details">
                  <div class="tc_content_custom">
                    <div className="seller-content">
                      From foreclosures and REO properties to CWCOT and short
                      sales, our marketing platform assists mortgage servicers,
                      financial institutions and individuals in easily
                      liquidating their properties. And, our innovative
                      technology allows sellers to oversee their own auctions
                      and listings every step of the way. Through our Signature
                      Seller Auctions, anyone looking to sell their properties
                      at auction can do so with ease.{" "}
                      <a href="/sell-a-home-in-an-online-auction/?option=register">
                        Click here
                      </a>{" "}
                      to find out how you can sell on Hubzu.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End .row */}
        </div>
      </section>

      <div className="global-impact pt-5">
        <div className="row">
          <div className="why-choose main-title text-center">
            <h2>Global Impact</h2>
            <p>
              Hubzu is a business unit of Altisource®, a leading service
              provider for the mortgage and real estate industries. Our
              marketing platform has been a part of the Altisource organization
              since 2012, and in that time, our global resources have allowed us
              to provide residential auction and property marketing services to
              millions of users around the world. To learn more, visit
              Altisource.com.
            </p>
          </div>
        </div>
      </div>

      <section className="milestone-section-abs">
        <div className="container">
          <div className="why-choose text-center">
            <h2>Our numbers speak for themselves</h2>
          </div>
          <div className="row pt40">
            <div className="col-sm-6 col-lg-12 milestone-numbers">
              <div className="row">
                <div className="col-12 col-lg-3">
                  <div className="mx-auto m-container">
                    <h3 className="mb-3 milestone">
                      {webCMS?.propertiesSold
                        ? webCMS?.propertiesSold
                        : "230,000"}
                      +
                    </h3>
                    <p className="fs-8 milestone-text mb-0">Properties Sold</p>
                  </div>
                </div>
                <div className="col-12 col-lg-3 mb-12 mb-lg-0">
                  <div className="mx-auto m-container">
                    <h3 className="mb-3 milestone">
                      {webCMS?.usersCount ? webCMS?.usersCount : "1.9"}+
                    </h3>
                    <p className="fs-8 milestone-text mb-0">Million Users</p>
                  </div>
                </div>
                <div className="col-12 col-lg-3">
                  <div className="mx-auto m-container">
                    <h3 className="mb-3 milestone">
                      {webCMS?.propertiesListed
                        ? webCMS?.propertiesListed
                        : "3,000"}
                      +
                    </h3>
                    <p className="fs-8 milestone-text mb-0">
                      Properties listed at any given time
                    </p>
                  </div>
                </div>

                <div className="col-12 col-lg-3 mb-12 mb-lg-0">
                  <div className="mx-auto m-container">
                    <h3 className="mb-3 milestone">
                      {webCMS?.experience ? webCMS?.experience : "10"}+
                    </h3>
                    <p className="fs-8 milestone-text mb-0">
                      Years of experience
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="bottom-bg"></div>
      <section>
        <div className="container">
          <div className="why-choose-cards">
            <WhyChoose />
          </div>
        </div>
        {/* End .row */}
      </section>
      <section className="our-story">
        <div className="container">
          <h2>Our Story</h2>
          <p>
            Over the past decade, we have redefined what it means to be a real
            estate marketing platform. And, our story is just beginning.
          </p>
          <div className="ourstory-img">
            <img
              alt="timeline-dsktp"
              className="d-none d-md-block"
              src="https://image-prod.hubzu.com/about-us/timeline-dsktp.jpg"
            />
            <img
              alt="timeline-mobile"
              className="d-block d-md-none"
              src="https://image-prod.hubzu.com/about-us/timeline-mobile.jpg"
            ></img>
          </div>
        </div>
      </section>
      <section class="register-section pb90">
        <div class="container">
          <div class="row">
            <div class="col-sm-6">
              <div class="modern_apertment">
                <h2 class="title">Join Our Team</h2>
                <p>
                  People with the drive and attitude to question, research and
                  problem-solve are everywhere here. We live and breathe the
                  "test and learn" methodology.
                </p>
                <a
                  class="btn booking_btn btn-thm"
                  href="https://altisource.com/Careers"
                >
                  Join The Team
                </a>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="modern_apertment">
                <h2 class="title">Register Today</h2>
                <p>
                  Join for free and start enjoying the benefits of being part of
                  one of the leading real estate marketing platforms.
                </p>
                <a
                  class="btn booking_btn btn-thm"
                  href="/register-sign-in"
                  onClick={(e) => navigateToRegister(e)}
                >
                  Register Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Our Footer --> */}
      {/* <section className="footer_one home6 bg-ptrn2">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
         <div className="container-fluid px-0">
                      <OtherLinkFooter/>
                      <NewFooter/>
                  </div>

      {/* <!-- Our Footer Bottom Area --> */}
      {/* <section className="footer_middle_area pt40 pb40">
        <div className="container">
          <CopyrightFooter />
        </div>
      </section> */}
    </>
  );
};

export default index;
